<template>
  <div
    :id="figId + '-wrapper'"
    class="fixed-grid min-width"
    :class="[figId]"
    v-observe-visibility="{
      callback: scrollChanged,
      intersection: { rootMargin: '700px 0px 100px' }
    }"
  >
    <figure :id="figId">
      <object
        class="c-1--1 r-1-4"
        type="image/svg+xml"
        :data="svgLib.palette"
        id="ali-palette"
        >Color palette diagram and explanation</object
      >
      <svg class="c--5--2 r-1-4" viewBox="0 0 489 622">
        <defs>
          <!-- Masks -->
          <rect
            id="ali-reveal-crop"
            x="87"
            y="0"
            :width="reveal"
            height="536"
          />
          <mask id="ali-reveal-mask" fill="white">
            <use href="#ali-reveal-crop" />
          </mask>
        </defs>
        <title>Comparing color palettes</title>
        <image
          id="property-panel-old"
          x="87"
          y="0"
          width="231"
          height="536"
          href="@/assets/work/alibaba/content/color-compare/property-panel.png"
        />
        <image
          id="property-panel-new"
          x="87"
          y="0"
          width="231"
          height="536"
          mask="url(#ali-reveal-mask)"
          href="@/assets/work/alibaba/content/color-compare/property-panel-new.png"
        />
        <text text-anchor="start" :opacity="newOpacity">
          <tspan x="87" y="560" class="text-title text-second">NEW</tspan>
          <!-- eslint-disable-next-line prettier/prettier -->
          <tspan x="87" y="577" class="text-title text-second">PALETTE</tspan>
        </text>
        <text text-anchor="end" :opacity="oldOpacity">
          <!-- eslint-disable-next-line prettier/prettier -->
          <tspan x="318" y="560" class="text-title text-second">PREVIOUS</tspan>
          <!-- eslint-disable-next-line prettier/prettier -->
          <tspan x="318" y="577" class="text-title text-second">PALETTE</tspan>
        </text>
        <line
          :x1="87 + reveal"
          y1="0"
          :x2="87 + reveal"
          y2="536"
          stroke="#00baff"
          stroke-width="2"
        />
        <rect fill="#0A0B0D" x="342" y="312" width="48" height="48" />
        <text class="text-mid">
          <tspan x="398" y="324">Base</tspan>
        </text>
        <rect fill="#14161A" x="342" y="240" width="48" height="48" />
        <text class="text-mid">
          <tspan x="398" y="252">Header /</tspan>
          <tspan x="398" y="268">Toned-down</tspan>
          <tspan x="398" y="284">Element</tspan>
        </text>
        <rect fill="#1F2126" x="342" y="168" width="48" height="48" />
        <text class="text-mid">
          <tspan x="398" y="180">Disabled</tspan>
          <tspan x="398" y="196">Element</tspan>
        </text>
        <rect fill="#292C33" x="342" y="96" width="48" height="48" />
        <text class="text-mid">
          <tspan x="398" y="108">Actionable</tspan>
          <tspan x="398" y="124">Element</tspan>
        </text>
        <rect fill="#333740" x="342" y="24" width="48" height="48" />
        <text class="text-mid">
          <tspan x="398" y="36">Hovered /</tspan>
          <tspan x="398" y="52">Border</tspan>
        </text>
        <path d="M318,336 L342,336" class="ali-pointer" />
        <path d="M309,255 L342,255" class="ali-pointer" />
        <path
          d="M238,462 L330,462 L330,257 C331.333333,257 332,256.333333 332,255 C332,253.666667 331.333333,253 330,253 L330,192 L342,192"
          class="ali-pointer"
        />
        <path d="M309,120 L343,120" class="ali-pointer" />
        <path d="M309,42 L342,42" class="ali-pointer" />
      </svg>
      <vue-slider
        class="c--5--2 r-3 ali-reveal-slider"
        v-model="reveal"
        :max="revealMax"
        :duration="0"
        tooltip="none"
        :railStyle="{ borderRadius: 0, backgroundColor: 'transparent' }"
        :processStyle="{ borderRadius: 0, backgroundColor: 'transparent' }"
        @mouseenter.native="handleHoverDot(true)"
        @mouseleave.native="handleHoverDot(false)"
      />
      <figcaption class="c-x--2 r-3-4 bottom line text-second">
        Redesigned color palette system and UI elements.
      </figcaption>
    </figure>
  </div>
</template>

<style lang="scss">
@import '@/styles/base.scss';

.ali-reveal-slider {
  margin-left: 87 / 489 * 100%;
  margin-right: 171 / 489 * 100%;
}
</style>

<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
// import anime from 'animejs'

export default {
  name: 'ali-colors',
  data() {
    return {
      svgLib: {
        palette: require('@/assets/work/alibaba/content/color-palette.svg')
      },
      figId: 'ali-colors',
      reveal: 0,
      revealMax: 231,
      revealThreshold: 84,
      dotHovered: false,
      percentObserver: null,
      percentObserving: false,
      percentObserved: null,
      percentOptions: {
        root: null,
        rootMargin: '600px 0px -100px',
        threshold: []
      }
    }
  },
  components: {
    VueSlider
  },
  computed: {
    newOpacity() {
      return this.reveal > this.revealThreshold
        ? 1
        : this.reveal / this.revealThreshold
    },
    oldOpacity() {
      return this.revealMax - this.reveal > this.revealThreshold
        ? 1
        : (this.revealMax - this.reveal) / this.revealThreshold
    }
  },
  methods: {
    handleHoverDot(hovered) {
      // console.log(this.dotHovered)
      this.dotHovered = hovered
    },
    scrollChanged(isVisible) {
      if (isVisible) {
        if (!this.percentObserving) {
          this.percentObserving = true
          this.percentObserver.observe(this.percentObserved)
        }
      } else {
        if (this.percentObserving) {
          this.percentObserving = false
          this.percentObserver.unobserve(this.percentObserved)
        }
      }
    },
    scrollPercent(entries) {
      entries.forEach(entry => {
        if (!this.dotHovered) {
          this.reveal = entry.intersectionRatio * this.revealMax
        }
      })
    }
  },
  mounted() {
    let thresholdSet = []
    for (let i = 0; i <= 1.0; i += 0.01) {
      thresholdSet.push(i)
    }
    this.percentOptions.threshold = thresholdSet
    this.percentObserver = new IntersectionObserver(
      this.scrollPercent,
      this.percentOptions
    )
    this.percentObserved = document.querySelector('#ali-colors-wrapper')
  }
}
</script>
